import { Filter16 } from "@carbon/icons-react";
import React from 'react';
export default {
  Filter16,
  React
};